<template>
	<div class="imofalform5FormHeader puiformheader">
		<v-row>
			<v-col cols="12">
				<pui-field :label="$t('header.imofalform5.familyname')" :value="getFamilynameValue"></pui-field>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'imofalform5-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'imofalform5'
		};
	},
	computed: {
		getFamilynameValue() {
			return this.model && this.model.familyname ? this.model.familyname : '-';
		}
	}
};
</script>
